/* global Dropdown, queryClass */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/predicateParts';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CRITERIA_PREDICATE_PART_METADATA);

export const useGetCriteriaPredicatePartMetadata = ({ sessionToken, partId }) => {
    const Client = apiClient(crudConfig.metadata);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: async () => {
            const config = await Client.fetch(sessionToken);

            if (!config) return {};
            const filterMap = new Map();
            filterMap.set('partId', partId);
            const propertyMap = new Map();
            propertyMap.set(queryClass, 'FindAll');
            const dataInputNodeDTOOptions = await (() =>
                new Promise((resolve) => {
                    Dropdown.getList(
                        config.fieldMap.dataInputNodeDTO.referenceResourcePlugin,
                        config.fieldMap.dataInputNodeDTO.referenceResourceName,
                        filterMap,
                        undefined,
                        propertyMap,
                        function(data, jqxhr) {
                            resolve(data);
                        }
                    );
                }))();

            return {
                enumMaps: {
                    partType: config?.fieldMap?.partType?.enum?.enumMap ?? {},
                    dataInputClassType: config?.fieldMap?.dataInputClassType?.enum?.enumMap ?? {},
                    conceptSelectionType: config?.fieldMap?.conceptSelectionType?.enum?.enumMap ?? {},
                    resourceType: config?.fieldMap?.resourceType?.enum?.enumMap ?? {},
                    dataInputNodeDTO: (dataInputNodeDTOOptions ?? []).reduce((acc, curr) => {
                        return {
                            ...acc,
                            [curr.nodeId]: `${curr.templateName} ${curr.nodePath}`
                        };
                    }, {})
                },
                options: {
                    dataInputNodeDTO: dataInputNodeDTOOptions
                }
            };
        },
        onSuccess: (data) => {},
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
